module.exports = __webpack_public_path__ + "static/media/ice34.b64df4b3.webp";